<script lang="ts">

    export let title = "";

</script>

<!-- toggle if you click anywhere in the whole component
<svelte:window on:click={() => expanded = false}/>
-->

<div class="card-wrapper">
    <span class="card-el w-100">
        <div style="display:{title? 'block': 'none'}" class="card-title">{title}</div>
        <div class="card-content">
            <slot name="content"></slot>
        </div>
    </span>
</div>
<style lang="scss">

  .card-wrapper{
    margin: 0;
    padding: 0;
    position: relative;
    width: 100%;
    height: 100%;
  }

  .accordion-wrapper *{

    margin:0;

  }
    .card-el {
      border-radius: 10px;
      width: 97%;
      //position: absolute;
      display: inline-block;
      /* font-size: x-large; */
      font-weight: normal;

      overflow: hidden;

      text-align: left;
      white-space: nowrap;
      color: #000000;
      outline: none;
      background-color: #FFFFFF;

      z-index: 99;
      padding: 10px;
      padding-right: 2rem;
      padding-left: 2rem;

    }



    .card-title{
      height: 32px;
      font-size:20px;
    }
    .card-content{
      margin-top:20px;
      padding-top:20px;
      padding-bottom:10px;
      white-space: pre-line;
    }

</style>
